import { render, staticRenderFns } from "./TablaOrden.vue?vue&type=template&id=dcc6e58c"
import script from "./TablaOrden.vue?vue&type=script&lang=js"
export * from "./TablaOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports